import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fafc2e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uk-margin-large-top uk-width-1-1 uk-flex uk-flex-stretch uk-flex-center uk-flex-middle uk-height-1-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "dot1" }),
    /*#__PURE__*/_createElementVNode("div", { class: "dot2" })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "uk-text-muted uk-text-italic" }, " Loading... ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}